var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_1087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 5.33331H19.1665L27.3332 13.5V26.3333C27.3332 26.9522 27.0873 27.5456 26.6498 27.9832C26.2122 28.4208 25.6187 28.6666 24.9998 28.6666H10.9998C10.381 28.6666 9.78751 28.4208 9.34992 27.9832C8.91234 27.5456 8.6665 26.9522 8.6665 26.3333V7.66665C8.6665 7.04781 8.91234 6.45432 9.34992 6.01673C9.78751 5.57915 10.381 5.33331 10.9998 5.33331Z",
    stroke: "#541FF3",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1665 5.33331V13.5H27.3332",
    stroke: "#541FF3",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 35.7,
    height: 35.7,
    rx: 2.85,
    stroke: "#E6E6E6",
    strokeWidth: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_1087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.ab0f08ed89d45843223f01ff3ef7c568.svg";
export { ForwardRef as ReactComponent };